import type { IntrinsicComponent } from "@/types/components";
import { defineComponent } from "vue";
import { cn } from "@/utils/cn";

const Card = defineComponent({
  name: "Card",
  setup(_, { slots, attrs }) {
    return () => (
      <div class={cn("rounded border bg-card text-card-foreground shadow-sm", attrs.class ?? "")}>
        {slots.default?.()}
      </div>
    );
  },
}) as IntrinsicComponent<"div">;

const Header = defineComponent({
  name: "CardHeader",
  setup(_, { slots, attrs }) {
    return () => (
      <div class={cn("flex flex-col gap-y-1.5 p-6", attrs.class ?? "")}>{slots.default?.()}</div>
    );
  },
}) as IntrinsicComponent<"div">;

const Title = defineComponent({
  name: "CardTitle",
  setup(_, { slots, attrs }) {
    return () => (
      <h3 class={cn("text-base font-semibold leading-none tracking-tight", attrs.class ?? "")}>
        {slots.default?.()}
      </h3>
    );
  },
}) as IntrinsicComponent<"h3">;

const Description = defineComponent({
  name: "CardDescription",
  setup(_, { slots, attrs }) {
    return () => (
      <p class={cn("max-w-5xl text-sm text-muted-foreground", attrs.class ?? "")}>
        {slots.default?.()}
      </p>
    );
  },
}) as IntrinsicComponent<"p">;

const Content = defineComponent({
  name: "CardContent",
  setup(_, { slots, attrs }) {
    return () => <div class={cn("p-6 pt-0", attrs.class ?? "")}>{slots.default?.()}</div>;
  },
}) as IntrinsicComponent<"div">;

const Footer = defineComponent({
  name: "CardFooter",
  setup(_, { slots, attrs }) {
    return () => (
      <div class={cn("flex items-center p-6 pt-0", attrs.class ?? "")}>{slots.default?.()}</div>
    );
  },
}) as IntrinsicComponent<"div">;

Card.Header = Header;
Card.Title = Title;
Card.Description = Description;
Card.Content = Content;
Card.Footer = Footer;

export default Card as typeof Card & {
  Header: typeof Header;
  Title: typeof Title;
  Description: typeof Description;
  Content: typeof Content;
  Footer: typeof Footer;
};
